'use client'

import { ACTIVE_ROLE_LABELS, useActiveRole } from '@/lib/active-role'
import { cn } from '@/lib/utils'

/** The signed-in user's role, as Keycloak assigns it. Read-only: to see another role, sign in as a user who has it. */
export function RoleBadge({ isCollapsed = false }: { isCollapsed?: boolean }) {
  const { activeRole } = useActiveRole()

  return (
    <div className={cn('space-y-1', isCollapsed && 'sr-only')}>
      <p className='text-xs font-medium text-text-secondary'>Signed in as</p>
      <p className='rounded-md border border-border-default px-2 py-1.5 text-sm text-text-primary'>{ACTIVE_ROLE_LABELS[activeRole]}</p>
    </div>
  )
}
